import React, { PureComponent } from 'react'

// local components
import DeliveryTaxItem from './DeliveryTaxItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const DeliveryTaxItemEditable = EditableHOCWrapper(DeliveryTaxItem)

class DeliveryTaxItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onTerminalUpdate(data, afterOnSave)
  }

  render() {
    const { data = {}, lastModified = null, regions = [], onEdit, onDelete } = this.props

    return (
      <DeliveryTaxItemEditable
        dataToEdit={data}
        onSave={this.onSave}
        lastModified={lastModified}
        regions={regions}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    )
  }
}

export default DeliveryTaxItemContainer



// WEBPACK FOOTER //
// ./src/components/DeliveryTax/DeliveryTaxItemContainer.js